import { render, staticRenderFns } from "./NewCustomContentFromFileModal.vue?vue&type=template&id=fe548872&scoped=true"
import script from "./NewCustomContentFromFileModal.vue?vue&type=script&lang=js"
export * from "./NewCustomContentFromFileModal.vue?vue&type=script&lang=js"
import style0 from "./NewCustomContentFromFileModal.vue?vue&type=style&index=0&id=fe548872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe548872",
  null
  
)

export default component.exports